import { MinusIcon, PlusIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { Button, Input } from '@/_components';
import type { DecimalCounterInputProps } from '@/_components/form-components/input/counter/use-decimal-counter-input';
import { useDecimalCounterInput } from '@/_components/form-components/input/counter/use-decimal-counter-input';

export function CellCounterInput({
  ...props
}: DecimalCounterInputProps & {
  hasIssue?: boolean;
}) {
  const { inputValue, min, decrement, increment, handleChangeInput, handleBlur, className, rest } =
    useDecimalCounterInput(props);

  return (
    <div className="flex flex-nowrap items-end gap-x-1">
      <div className="border-c-border border-b-2 px-1 pb-1.5">
        <Button
          size="xs"
          as="outline"
          className="rounded-md"
          iconClassName="size-3"
          onClick={decrement}
          icon={MinusIcon}
          disabled={parseInt(`${inputValue}`, 10) <= min}
          aria-label="Minus"
        />
      </div>
      <Input
        {...rest}
        value={inputValue}
        onChange={handleChangeInput}
        onBlur={handleBlur}
        containerProps={{ className: 'h-6 w-12 min-w-12 max-w-12' }}
        className={twMerge('rounded-none border-b-2 px-0.5 pt-0.5 pb-0.5 text-center text-xs', className)}
      />
      <div className="border-c-border border-b-2 px-1 pb-1.5">
        <Button
          size="xs"
          as="outline"
          className="rounded-md"
          iconClassName="size-3"
          aria-label="Plus"
          onClick={increment}
          icon={PlusIcon}
        />
      </div>
    </div>
  );
}
